import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { APIS } from '../../common/constants';
import { Observable } from 'rxjs';
import { InspectionData, InspectionReportUrl } from '../../models/inspection.model';
import { InspectionDataResponse } from '../../models/inspection.model';

@Injectable({
  providedIn: 'root'
})
export class InspectionsService {

  constructor(
    private httpService: HttpService
  ) {
  }

  createInspectionFromOrders(data: Record<string, any>): Observable<any> {
    return this.httpService.postData(APIS.INSPECTIONS.BASE, data);
  }

  createInspectionFromFile(data: Record<string, any>): Observable<any> {
    return this.httpService.postData(APIS.INSPECTIONS.IMPORT_FILE, data);
  }

  getInspections(query: Record<string, any>): Observable<{
    data: InspectionData[],
    total: number,
    totalPendingClientDecision: number
  }> {
    return this.httpService.getData(APIS.INSPECTIONS.BASE, { ...query, context: 'planningApp' });
  }

  updateClientDecision(clientDecisionId: string, inspId: string): Observable<any> {
    return this.httpService.putData(
      APIS.INSPECTIONS.UPDATE_CLIENT_DECISION.replace(':id', inspId),
      { clientDecisionId }
    );
  }

  getReportVersions(inspId: string): Observable<any> {
    return this.httpService.getData(APIS.INSPECTIONS.REPORT_VERSIONS.replace(':id', inspId));
  }

  getInspectionReportPdf(inspId: string): Observable<InspectionReportUrl> {
    return this.httpService.getData(APIS.INSPECTIONS.PDF_REPORT.replace(':id', inspId));
  }

  update(id: string, data: Record<string, any>): Observable<any> {
    return this.httpService.putData(`${APIS.INSPECTIONS.BASE}/${id}`, data);
  }

  sync(id: string, data: Record<string, any>): Observable<any> {
    return this.httpService.putData(`${APIS.INSPECTIONS.SYNC}/${id}`, data);
  }

  delete(id: string): Observable<any> {
    return this.httpService.deleteData(`${APIS.INSPECTIONS.BASE}/${id}`);
  }

  getInspectionDetail(id: string): Observable<InspectionDataResponse> {
    return this.httpService.getData(`${APIS.INSPECTIONS.BASE}/${id}`);
  }

}
